import { config } from '@react-spring/web';
import type { PropsWithChildren } from 'react';
import { BaseModal } from './base-modal';

type SideMenuProps = {
  isOpen: boolean;
  onClose: () => void;
  label?: string;
  preventAutofocusOnOpen?: boolean;
};

export const SideMenu = ({ children, isOpen, onClose, label, preventAutofocusOnOpen = false }: PropsWithChildren<SideMenuProps>) => (
  <BaseModal
    isOpen={isOpen}
    onClose={onClose}
    className="top-0 bottom-0 right-0 flex flex-col tds-side-menu gap-600"
    label={label}
    preventAutofocusOnOpen={preventAutofocusOnOpen}
    animation={{
      from: { x: 200 },
      enter: { x: 0 },
      leave: { x: 200 },
      config: config.stiff,
    }}
    dismissable={true}>
    {children}
  </BaseModal>
);
